import { all } from 'redux-saga/effects'

import auth from './auth/sagas'
import student from './student/sagas'
import subscription from './subscription/sagas'
import learningCourses from './learningCourses/sagas'
import dashboard from './dashboard/sagas'

export default function* rootSaga(): any {
  return yield all([auth, student, subscription, learningCourses, dashboard])
}
